import React__default, { useContext, useState, useEffect, createContext } from "react";
const VOICE_COMPACT_MEDIA_QUERY = "(max-width: 759.98px)";
const SSR_DEFAULT = false;
const CompactLayoutOverrideContext = createContext(null);
const CompactLayoutOverrideProvider = ({
  value,
  children
}) => {
  return React__default.createElement(CompactLayoutOverrideContext.Provider, { value }, children);
};
function useIsCompactVoiceLayout() {
  const override = useContext(CompactLayoutOverrideContext);
  const [isCompact, setIsCompact] = useState(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
      return SSR_DEFAULT;
    }
    return window.matchMedia(VOICE_COMPACT_MEDIA_QUERY).matches;
  });
  useEffect(() => {
    var _a;
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return;
    const mql = window.matchMedia(VOICE_COMPACT_MEDIA_QUERY);
    const handler = (e) => setIsCompact(e.matches);
    setIsCompact(mql.matches);
    if (typeof mql.addEventListener === "function") {
      mql.addEventListener("change", handler);
      return () => mql.removeEventListener("change", handler);
    }
    (_a = mql.addListener) == null ? void 0 : _a.call(mql, handler);
    return () => {
      var _a2;
      (_a2 = mql.removeListener) == null ? void 0 : _a2.call(mql, handler);
    };
  }, []);
  if (override !== null) return override;
  return isCompact;
}
export {
  CompactLayoutOverrideProvider,
  VOICE_COMPACT_MEDIA_QUERY,
  useIsCompactVoiceLayout
};
//# sourceMappingURL=useIsCompactVoiceLayout.js.map
